import { useEffect, useMemo, useRef, useState } from "react"
import styles from './index.module.scss'
import { forwardRef } from "react"
import * as _ from "underscore";
import LabelBox from "../LabelBox"
import ImageRender from "../ImageRender"
import LabelToolBox from "../LabelToolBox"
import { useDrag, useDrop, useDragLayer } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import Iconfont from '@utils/Iconfont';
import Utils from "@utils/utils"
import ImageRenderBox from "../ImageRenderBox";
import _Multiple from "./multiple"
import { Image } from "antd";

const ImageItem = (props) => {
    const { index, actived } = props
    const [{ isDragging }, drag, preview] = useDrag({
        type: 'DragDropReplaceBox',
        item: { index },
        end: (item, monitor) => {},
        isDragging: (monitor) => {
            return index === monitor.getItem().index;
        },
        canDrag: () => true,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    return (
        <div
            ref={drag}
            className={`${styles.ResourceItem} ${actived && styles.actived}`}
            onClick={props.onSelect}
        >
            <Image src={Utils.getImgThumbnail(props.src)} preview={false} fallback={props.src} />
            <span>{props.name}</span>
        </div>
    )
}

const ImagePreviewRender = (props) => {
    const [skuItems] = useState(props.skuItems)
    const [dispalyList, setDisplayList] = useState([])
    const [nofixedReousrce] = useState(props.currentItem.filter(item => !item.fixed))
    
    const hasBottom = useMemo(() => {
        return true
    }, [nofixedReousrce, props.children])

    useEffect(() => {
        const nofixedReousrce = props.currentItem.filter(item => !item.fixed)
        const fixedReousrce = props.currentItem.filter(item => item.fixed)

        let middleItem =
            fixedReousrce.find(item => item.defaultOpen == "middle") ||
            nofixedReousrce.find(item => item.defaultOpen == "middle")
        let leftItem =
            fixedReousrce.find(item => item.defaultOpen == "left") ||
            nofixedReousrce.find(item => item.defaultOpen == "left")
        let rightItem =
            fixedReousrce.find(item => item.defaultOpen == "right") ||
            nofixedReousrce.find(item => item.defaultOpen == "right")

        if (!leftItem) leftItem = nofixedReousrce.filter(item => item.name != middleItem?.name && item.name != rightItem?.name)[0]
        if (!rightItem) rightItem = nofixedReousrce.filter(item => item.name != middleItem?.name && item.name != leftItem?.name)[0]
        setDisplayList([leftItem, middleItem, rightItem])
    }, [])

    const handleSelect = (item) => {
        setDisplayList(pre => {
            const temp = [...pre]
            let left = temp[0]
            let right = temp[2]
            let isActived = temp.find(i => i?.name == item.name)
            if (isActived) {
                let removeIndex = left?.name == item.name ? 0 : 2
                temp.splice(removeIndex, 1, null)
            } else {
                if (!left) {
                    temp.splice(0, 1, item)
                } else if (!right) {
                    temp.splice(2, 1, item)
                } else {
                    temp.splice(0, 1, item)
                }
            }
            return temp
        })
    }

    const handleSwap = (from, to) => {
        setDisplayList(pre => {
            const temp = [...pre]
            const tempItem = temp[from]
            temp[from] = temp[to]
            temp[to] = tempItem
            return [...temp]
        })
    }

    const handleReplace = (from, to) => {
        setDisplayList(pre => {
            const temp = [...pre]
            const fromItem = nofixedReousrce[from]
            let index = temp.findIndex(i => i?.name == fromItem.name)
            if (index >= 0) {
                if (index == to) return temp
                else {
                    const tempItem = temp[index]
                    temp[index] = temp[to]
                    temp[to] = tempItem
                }
            } else {
                temp.splice(to, 1, fromItem)
            }
            return temp
        })
    }

    return (
        <div className={styles.ImagePreviewRender}>
            <div className={styles.ImageBox} style={{marginBottom: hasBottom ? 0 : 15}}>
            {
                dispalyList.map((item, index) => (
                    <ImageRenderBox
                        key={item?.name||index}
                        item={item}
                        index={index}
                        fixedable={false} // 不可固定
                        canDrag={!item?.fixed}
                        canSwapDrop={!item?.fixed}
                        canReplaceDrop={!item?.fixed}
                        onLabel={item?.onLabel}
                        onSwap={handleSwap}
                        onReplace={handleReplace}
                        downloadable={item?.downloadable}
                    />
                ))
            }
            </div>
            {
                hasBottom ?
                <div className={styles.BottomBox}>
                    <div className={styles.SkuBox}>
                        <div className={`${styles.MultipleTrigger} ${styles.Multiple}`} onClick={() => props.onMultiple(true)}>
                            <div></div>
                            <span>验收全部</span>
                        </div>
                        {/* Master Only */}
                        {
                            skuItems.map(item => (
                                <div
                                    key={item.skuId}
                                    className={`${styles.SkuItem} ${(props.current?.skuId == item.skuId) && styles.actived}`}
                                    onClick={() => props.onSelectSku(item)}
                                >
                                    <Image src={Utils.getImgThumbnail(item.skuImage)} preview={false} fallback={item.skuImage} />
                                </div>
                            ))
                        }
                    </div>
                    <div className={styles.ResourceBox}>
                        {
                            nofixedReousrce.map((item, index) => (
                                <ImageItem
                                    key={index}
                                    index={index}
                                    actived={dispalyList.find(i => i?.name == item.name)}
                                    onSelect={() => handleSelect(item)}
                                    src={item.url}
                                    name={item.name}
                                />
                            ))
                        }
                    </div>
                    <div></div>
                </div> : null
            }            
        </div>
    )
}

ImagePreviewRender.Multiple = _Multiple

export default ImagePreviewRender